// Lightweight entry point for the public landing page.
// Keeps the standalone marketing page free of the full application bundle;
// only Stimulus + the wordmark rotator ship to anonymous visitors.
import { Application } from "@hotwired/stimulus"
import WordmarkRotatorController from "./controllers/wordmark_rotator_controller"

const application = Application.start()
application.register("wordmark-rotator", WordmarkRotatorController)
